import { DepositType, WithdrawalType } from '@models/user/enums';
import { HistoryType } from '@store/modules/ui/user/history/enums';

export default {
    services: {
        smdc: {
            // list of shops which are more accurate than comtrade's.
            // we need to filter out all shops from cometrade which doesn't ecist in smdc
            host: 'https://smdc.superbet.pl',
            authorizationKey: 'Qu6u>7F!JTq}<sXyij20v&iY@fW=;E',
        },
        cashout: {
            isAvailable: true,
        },
    },
    auth: {
        usernameValidChars: '[A-Za-z0-9@$!%*#?&ăâîşţąćęłńóśźż]+',
        polishNationality: 'Polacy',
        polandId: '174',
        portalDesktopId: 'Desktop',
        portalMobileId: 'Mobile',
        registerUrl: 'registrationFirstStep',
    },
    user: {
        idCardVerification: {
            period: 90 // in days. if user doesn't upload id card account will be disabled
        },
        withdrawal: {
            availableTypes: {
                [WithdrawalType.online]: true,
                [WithdrawalType.bankTransfer]: true,
            },
            isTaxable: false,
        },
        deposit: {
            availableTypes: {
                [DepositType.online]: true,
                [DepositType.bankTransfer]: true,
                [DepositType.shop]: true,
            },
            isTaxable: false,
        },
        history: {
            availableTypes: {
                [HistoryType.transactions]: true,
                [HistoryType.bets]: true,
            },
        },
        tempAccountMaxWin: 2279.99,
    },
    sport: {
        isStreamAvailable: false,
    },
    footer: {
        payments: [
            {
                path: 'metode-de-plata-transfer-bancar',
                img: 'img_bank_transfer.png',
                width: '154',
                height: '20',
            },
            {
                path: 'metode-de-plata-online#visa-master',
                img: 'img_visa.png',
                width: '43',
                height: '14',
            },
            {
                path: 'metode-de-plata-online#visa-master',
                img: 'img_mastercard.png',
                width: '112',
                height: '20',
            },
            {
                path: 'metode-de-plata-online#skrill',
                img: 'img_skrill.png',
                width: '44',
                height: '15',
            },
            {
                path: 'metode-de-plata-online#neteller',
                img: 'img_neteller.png',
                width: '63',
                height: '11',
            },
        ],
        whatsAppNumber: 'POLANDWhatsApp',
        nonStopPhoneNumber: 'POLANDNUMBER',
        email: 'suport@superbet.pl',
        faqPage: 'POLANDFAQ',
    },
    betSlip: {
        allowSubmitWithMaxWin: false,
        validationsConfig: {
            isEnabledWinLowerThanStake: false,
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/config/index.ts